module.exports = __webpack_public_path__ + "b37640e39e5866d9f6a20b8b41206392.png";